module.exports = __webpack_public_path__ + "img/madera019.f16e3aaf.jpg";